module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Yksityisyysasetukset")]), _vm._v(" "), _vm._l((_vm.store.globalSettings.mobilePrivacyInfo.split('\n')), function(paragraph, i) {
    return _c('p', {
      key: i,
      staticClass: "about"
    }, [_vm._v("\r\n        " + _vm._s(paragraph) + "\r\n    ")])
  }), _vm._v(" "), _c('i18n', {
    staticClass: "about",
    attrs: {
      "path": "privacySettingsView.moreInfo",
      "tag": "p"
    }
  }, [_c('a', {
    attrs: {
      "place": "email",
      "href": 'mailto://' + _vm.sulEmail
    }
  }, [_vm._v(_vm._s(_vm.sulEmail))]), _vm._v(" "), _c('a', {
    attrs: {
      "place": "privacyPolicyUrl",
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openPrivacyPolicy()
      }
    }
  }, [_vm._v(_vm._s(_vm.privacyPolicyUrl))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-032e0ece","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/PrivacySettingsView.vue
// module id = 107
// module chunks = 0